var map = {
	"./de/header/button": [
		"wK2W",
		42
	],
	"./en/header/button": [
		"Ujly",
		26
	],
	"./fr/header/button": [
		"Kt4d",
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ptST";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/header\/button$
// module id = ptST
// module chunks = 70